import { render } from "./MenuLink.vue?vue&type=template&id=5a673098&ts=true"
import script from "./MenuLink.vue?vue&type=script&lang=ts"
export * from "./MenuLink.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__